var render = function render() {
    var _vm = this,
        _c = _vm._self._c,
        _setup = _vm._self._setupProxy;return _c('span', { staticClass: "skin-item", class: {
            'is-active': _vm.active
        }, on: { "click": function click($event) {
                return _vm.$emit('click');
            } } }, [_vm._t("default"), _vm._v(" "), _vm.showEdit ? _c('i', { staticClass: "el-icon-edit", on: { "click": function click($event) {
                $event.stopPropagation();return _vm.$emit('edit');
            } } }) : _vm._e(), _vm._v(" "), _vm.showClose ? _c('i', { staticClass: "el-icon-close", on: { "click": function click($event) {
                $event.stopPropagation();return _vm.$emit('close');
            } } }) : _vm._e()], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };